// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"Testimonial-styles-module--testimonial--2P6KV","frontendor":"Testimonial-styles-module--frontendor--3n-kd","dark":"Testimonial-styles-module--dark--9kQHQ"};